// extracted by mini-css-extract-plugin
export default {"container":"CompaniesList_container__39VBs","headerWrapper":"CompaniesList_headerWrapper__q5eMw"};